.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  align-items: flex-start;
}

/*
 * The answer to the question the page exists for. Left-aligned deliberately: the entity title
 * above it is centred, and a centred title over a left-aligned body reads as unfinished — the
 * body wins, because it is the part carrying the information.
 */
.lead {
  margin: 0;
  color: var(--tuna-content-primary);
}

.winners,
.alsoRanList {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.winner,
.alsoRan {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
}

.winnerLabel {
  min-width: 10rem;
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-body1-fontSize);
}

.alsoRanSection {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding-top: var(--tuna-spacing-2);
  border-top: 1px solid var(--tuna-border-subtle);
  /* The section is a footnote to the decision, so it stretches rather than hugging its text. */
  align-self: stretch;
}

.alsoRanHeading {
  color: var(--tuna-content-secondary);
}

/* Dimmer than a winner: these nights are context for the decision, not the decision. */
.alsoRanLabel {
  min-width: 10rem;
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
}

.notice {
  color: var(--tuna-content-muted);
}

/* Holds the row height while the responses land, so nothing jumps when they do. */
.skeleton {
  display: inline-block;
  width: 12rem;
  height: 24px;
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-palette-action-hover);
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }
}

/* The single column IS the mobile layout; only the rows stack. */
@media (max-width: 599.95px) {
  .winner,
  .alsoRan {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--tuna-spacing-1);
  }
}
